
function Title(props) {
  return (
    <span className="text-gray-10 text-2xl font-montserrat-b">
      {props.title}
    </span>
  );
}

export default Title;
